<template>
  <require from="components/application/application-bar"></require>
  <require from="components/application/application-menu"></require>

  <div class="application-frame ${mobileAppService.isMobileApp ? '--is-mobile-app' : ''}">
    <div class="application-frame__head">
      <application-bar router.bind="router" menu-toggled.bind="menuToggled"></application-bar>
    </div>
    <div class="application-frame__body">
      <div class="application-frame__menu ${menuToggled ? '--toggled' : ''}">
        <application-menu navigation.bind="router.navigation" nav-group-models.bind="navGroupModels" clicked.call="menuClicked()" collapsed.bind="menuCollapsed"></application-menu>
      </div>
      <div class="application-frame__main">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
